import { TaxRate } from './tax-rate';

export class MonetaryAmount {

    public static ZERO: MonetaryAmount  = new MonetaryAmount(0, null, null);
    constructor(public amount: number,
                public currency: string,
                public taxRate?: TaxRate) {}
}
